import { mergeAttributes, Node } from '@tiptap/core';

const ArticleVideo = Node.create({
  name: 'articleVideo',
  group: 'block',
  atom: true,
  draggable: true,
  isolating: true,

  addAttributes() {
    return {
      src: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-video-src')
          || element.querySelector('iframe, video')?.getAttribute('src')
          || '',
      },
      provider: {
        default: 'file',
        parseHTML: (element) => element.getAttribute('data-video-provider') || 'file',
      },
      title: {
        default: 'ویدیوی مقاله',
        parseHTML: (element) => element.getAttribute('data-video-title')
          || element.querySelector('iframe')?.getAttribute('title')
          || 'ویدیوی مقاله',
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-article-video]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const { src, provider, title } = HTMLAttributes;
    const wrapperAttributes = mergeAttributes({
      class: `article-video-node is-${provider}`,
      'data-article-video': '',
      'data-video-provider': provider,
      'data-video-src': src,
      'data-video-title': title,
    });

    if (provider === 'file') {
      return [
        'div',
        wrapperAttributes,
        ['video', {
          src,
          title,
          controls: '',
          playsinline: '',
          preload: 'metadata',
        }],
      ];
    }

    return [
      'div',
      wrapperAttributes,
      ['iframe', {
        src,
        title,
        loading: 'lazy',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
        allowfullscreen: 'true',
        referrerpolicy: 'strict-origin-when-cross-origin',
      }],
    ];
  },
});

export default ArticleVideo;
